import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const NotificationContext = createContext();

let nextId = 0;

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const timersRef = useRef({});

  const dismiss = useCallback((id) => {
    clearTimeout(timersRef.current[id]);
    delete timersRef.current[id];
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const notify = useCallback((message, type = 'success', duration = 5000) => {
    const id = ++nextId;
    setNotifications((prev) => [...prev, { id, message, type, duration }]);
    timersRef.current[id] = setTimeout(() => dismiss(id), duration);
    return id;
  }, [dismiss]);

  return (
    <NotificationContext.Provider value={{ notify, dismiss, notifications }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  return useContext(NotificationContext);
}
